import React, {useState, useEffect} from 'react';
import "../styles/adoption-box.css";
import Popup from '../components/payment-popup-components/Popup';
import AlertPopup from '../components/alert-popup/AlertPopup';
import allIndivialPuppies1 from '../data/individual-puppy-data/_split_restructured_puppies-data1.json'
// import allIndivialPuppies2 from '../data/individual-puppy-data/_split_restructured_puppies-data2.json'
// import allIndivialPuppies3 from '../data/individual-puppy-data/_split_restructured_puppies-data3.json'
// import allIndivialPuppies4 from '../data/individual-puppy-data/_split_restructured_puppies-data4.json'
// import allIndivialPuppies5 from '../data/individual-puppy-data/_split_restructured_puppies-data5.json'
// import allIndivialPuppies6 from '../data/individual-puppy-data/_split_restructured_puppies-data6.json'


const allPuppies: any[][] = [
  allIndivialPuppies1,
  // allIndivialPuppies2,
  // allIndivialPuppies3,
  // allIndivialPuppies4,
  // allIndivialPuppies5,
  // allIndivialPuppies6,
];

function findItemById<T extends { puppy_id: string }>(
      arrays: T[][],
      id: string | undefined
    ): T | undefined {
      for (const array of arrays) {
        const found = array.find(item => item.puppy_id === id);
        if (found) {
          return found;
        }
      }
      return undefined;
}


interface AdoptionStatusBoxProps {
    userData: any;
}

const AdoptionStatusBox: React.FC<AdoptionStatusBoxProps> = ({ userData }) => {

    const [ puppyInfo, setPuppyInfo ] = useState<any>({})
    const [needed, setNeeded] = useState(false)

    const [alert, setAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState('')
    const [alertMode, setAlertMode] = useState(false)

    useEffect(()=>{
        if(userData.puppyId){
            setPuppyInfo(findItemById(allPuppies, userData.puppyId))
        }
    }, [userData])
  

    return (
        <>
            <div className="adoption-box">
                <h2>Adoption Status</h2>

                <div className="info-section">
                    <h3>Travel Status</h3>
                    <p><strong>Current Status:</strong> {userData.tracker_current_status}</p>
                    <p><strong>Puppy Location:</strong> {userData.tracker_puppy_location}</p>
                    <p><strong>Transport Type:</strong> {userData.tracker_transport_type}</p>
                    <p><strong>Delivery Type:</strong> {userData.tracker_delivery_type}</p>
                    <p><strong>Estimated Time Left:</strong>{userData.tracker_estimated_time_left}</p>
                    {/*<p><strong>Shipping Cost:</strong> ${userData.tracker_trasnport_cost} {!userData.tracker_delivery_paid ? <span style={{color: 'red'}}>(Pending Payment)</span> : <span style={{color: 'green'}}>(Paid)</span>} </p>*/}
                    <p>
                          <strong>Shipping Cost:</strong> {userData.tracker_trasnport_cost} 

                          {userData.gees_transport_paid ? null :  userData.gees_payment_for === 'transport' ? (
                            <a onClick={()=> setNeeded(true)} style={{ color: 'blue', textDecoration: 'none', fontWeight: 'bold', cursor: 'pointer' }}>
                              Complete Payment
                            </a>
                          ) : (
                            <span style={{ color: 'red' }}>(Pending Payment)</span>
                          )}
                    </p>


                    {userData.tracker_message != "" ? <p><strong>Notification:</strong> {userData.tracker_message}</p> : null}
                </div>

                <div className="info-section">
                    <h3>Customer Information</h3>
                    <p><strong>Name:</strong> {userData.firstNameInput} {userData.lastNameInput}</p>
                    <p><strong>Email:</strong> {userData.emailInput}</p>
                    <p><strong>Phone:</strong> {userData.phoneNumber}</p>
                    <p><strong>Address:</strong> {userData.homeAddress}, {userData.city}, {userData.state}, {userData.zipCode}</p>
                    <p><strong>Approved:</strong> {userData.tracker_approved == 'No' ? <span style={{color: '#DAA520'}}>Padding</span> : <span style={{color: 'green'}}>Yes</span>} </p>

                </div>

                {
                    puppyInfo
                    ?
                    <div className="info-section">
                        <h3>Puppy Information</h3>
                        <p><strong>Name:</strong> {puppyInfo.puppy_name}</p>
                        <p><strong>Puppy ID:</strong> {puppyInfo.puppy_id}</p>
                        <p><strong>Breed:</strong> {puppyInfo.breed}</p>
                        <p><strong>Age:</strong> {puppyInfo.age}</p>
                        <p><strong>Gender:</strong> {puppyInfo.sex}</p>

                       <p>
                          <strong>Reservation Fee:</strong> {puppyInfo.price} 
                          {userData.gees_adoption_paid ? null : userData.gees_payment_for === 'adoption' ? (
                            <a onClick={()=> setNeeded(true)} style={{ color: 'blue', textDecoration: 'none', fontWeight: 'bold', cursor: 'pointer' }}>
                              Complete Payment
                            </a>
                          ) :  (
                            <span style={{ color: 'red' }}>(Pending Payment)</span>
                          )}
                        </p>
                        
                    </div>
                    :
                    null
                }            
                

                <div className="" style={{width: '100%', textAlign: 'center'}}>
                    <a href="mailto:info.puppyspotadoption@gmail.com" style={{fontSize: '0.7rem', textDecoration: 'underline'}}>Contact a puppy concierge</a>
                    {/*<h3>Status: <span className={`status-${status.toLowerCase()}`}>{status}</span></h3>*/}
                </div>
            </div>

            
              <Popup 
                needed={needed}
                setNeeded={setNeeded}
                userData={userData}

                setAlert={setAlert}
                setAlertMessage={setAlertMessage}
                setAlertMode={setAlertMode}
              />

                <AlertPopup 
                  alert={alert} 
                  setAlert={setAlert} 
                  alertMessage={alertMessage} 
                  setAlertMessage={setAlertMessage} 
                  alertMode={alertMode} 
                  setAlertMode={setAlertMode} 
                />
        </>
        
    );
};

export default AdoptionStatusBox;
